import { message } from 'antd';

import { call, put, takeEvery, all, fork, select, takeLatest } from 'redux-saga/effects'
import { getMisVerifiedAPI, undoReportFromHoldQueueAPI } from '../../../services/mis-service';
import { FETCH_VERIFIED, FETCH_VERIFIED_START, FETCH_VERIFIED_SUCCESS, FETCH_VERIFIED_ERROR, UNDO_REPORT_FROM_HOLD_QUEUE, UNDO_REPORT_FROM_HOLD_QUEUE_START, UNDO_REPORT_FROM_HOLD_QUEUE_SUCCESS, UNDO_REPORT_FROM_HOLD_QUEUE_ERROR, SET_VERIFIED_FILTER, SET_VERIFIED_PAGINATION } from '../../actions/mis/verifiedAction';

function* fetchVerified({ payload }) {
    try {
        yield put({ type: FETCH_VERIFIED_START })
        const response = yield call(getMisVerifiedAPI, payload);
        if (response.success) {
            const pagination = {
                currentPage: payload.page,
                pageSize: payload.size,
                totalPages: response.data.totalPages,
                totalItems: response.data.totalItems,
            }
            yield put({ type: FETCH_VERIFIED_SUCCESS, verified: response.data.misVerified });
            yield put({ type: SET_VERIFIED_PAGINATION, pagination });
            yield put({ type: SET_VERIFIED_FILTER, payload: { ...payload } });
        } else {
            yield put({ type: FETCH_VERIFIED_ERROR, error: response.error })
            message.error('Failed to fetch verified visits!');
        }
    } catch (error) {
        yield put({ type: FETCH_VERIFIED_ERROR, error })
        message.error('Failed to fetch verified visits!');
    }
}

function* undoReportFromHoldQueue({ payload }) {
    try {
        const { reportId } = payload;
        yield put({ type: UNDO_REPORT_FROM_HOLD_QUEUE_START })
        const response = yield call(undoReportFromHoldQueueAPI, payload);
        if (response.success) {
            yield put({ type: UNDO_REPORT_FROM_HOLD_QUEUE_SUCCESS, reportId });
            message.success('Undo successfully!');
        } else {
            if (response.error) {
                yield put({ type: UNDO_REPORT_FROM_HOLD_QUEUE_ERROR, error: response.error })
                message.error(response.error);
            } else {
                yield put({ type: UNDO_REPORT_FROM_HOLD_QUEUE_ERROR, error: response.error })
                message.error('Failed to undo report!');
            }
        }
    } catch (error) {
        yield put({ type: UNDO_REPORT_FROM_HOLD_QUEUE_ERROR, error })
        message.error('Failed to undo report!');
    }
}

function* misVerifiedWatcher() {
    yield takeEvery(FETCH_VERIFIED, fetchVerified)
    yield takeLatest(UNDO_REPORT_FROM_HOLD_QUEUE, undoReportFromHoldQueue)
}

export default function* rootSaga() {
    yield all([
        misVerifiedWatcher(),
    ]);
}